import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'

class SurveyQuestionList extends Component {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, surveyQuestionSettingList: []}
  }
  componentWillMount () {
    this.SurveyQuestionSettingList()
  }
  selected (survey, e) {
    this.props.history.push('/' + this.userRoleUrl + '/survey_mediumquestion/' + survey.id)
  }
  mediumselected (survey, e) {
    this.props.history.push('/' + this.userRoleUrl + '/survey_smallquestion/' + survey.id)
  }
  smallselected (survey, e) {
    this.props.history.push('/' + this.userRoleUrl + '/survey_smallquestion/edit/' + survey.id)
  }
  SurveyQuestionSettingList () {
    if(this.serveyCategory === "big") {
      const onSuccess = (res) => {
        const surveyQuestionSettingList = res.body.data
        this.setState({
          isLoaded: true,
          surveyQuestionSettingList: surveyQuestionSettingList,
        })
      }
      const params = {
        command: 'get'
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    } else if(this.serveyCategory === "medium") {
      const onSuccess = (res) => {
        const surveyQuestionSettingList = res.body.data
        this.setState({
          isLoaded: true,
          surveyQuestionSettingList: surveyQuestionSettingList,
        })
      }
      const params = {
        command: 'getMedium',
        surveyValue: this.props.match.params
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    } else if(this.serveyCategory === "small") {
      const onSuccess = (res) => {
        const surveyQuestionSettingList = res.body.data
        this.setState({
          isLoaded: true,
          surveyQuestionSettingList: surveyQuestionSettingList,
        })
      }
      const params = {
        command: 'getSmall',
        surveyValue: this.props.match.params
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    }
  }
  renderSurveyQustionBigListBox(state) {
    let surveyQuestionSettingList = state.surveyQuestionSettingList;

    // setsumon_sort の昇順でソート
    surveyQuestionSettingList = surveyQuestionSettingList.sort((a, b) => {
      if (a.setsumon_sort === b.setsumon_sort) {
        return a.id - b.id;
      }
      return a.setsumon_sort - b.setsumon_sort;
    });
    const setsumonTypeOptions = [
      { value: 1, label: '回答会社連絡先等' },
      { value: 2, label: '質問事項' },
    ]

    if (surveyQuestionSettingList.length) {
      return surveyQuestionSettingList.map((survey) => {
        const foundOption = setsumonTypeOptions.find(option => option.value == survey.setsumon_type);
        const setsumonTypeLabel = foundOption ? foundOption.label : '';
        return (
          <tr key={survey.id} onClick={(surveySetting, e) => this.selected(survey, e)}>
            <td>{survey.setsumon_title}</td>
            <td>{survey.setsumon_comment}</td>
            <td>{setsumonTypeLabel}</td>
            <td>{survey.setsumon_sort}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ textAlign: 'center' }} colSpan="4">データがありません</td>
        </tr>
      );
    }
  }
  renderSurveyQustionMediumListBox(state) {
    let surveyBigQuestion = state.surveyQuestionSettingList.bigQuestions;
    let surveyMediumQuestionList = state.surveyQuestionSettingList.mediumQuestions;
    const setsumonTypeOptions = [
      { value: 1, label: '回答会社連絡先等' },
      { value: 2, label: '質問事項' },
    ]

    // id の昇順でソート
    if (Array.isArray(surveyMediumQuestionList) && surveyMediumQuestionList.length > 0) {
      surveyMediumQuestionList = surveyMediumQuestionList.sort((a, b) => a.id - b.id);
    }

    let bigQuestionData = {};
    let mediumQuestionData = {};
    bigQuestionData = (
      <table className="table table-hover tablesorter">
        <thead>
          <tr>
            <th width="30%">大設問タイトル</th>
            <th>大設問コメント</th>
            <th width="15%">大設問タイプ</th>
            <th width="7%">ソート順</th>
          </tr>
        </thead>
        <tbody>
          {surveyBigQuestion.map((survey) => {
            const foundOption = setsumonTypeOptions.find(option => option.value == survey.setsumon_type);
            const setsumonTypeLabel = foundOption ? foundOption.label : '';
            return (
              <tr key={survey.id}>
                <td>{survey.setsumon_title}</td>
                <td>{survey.setsumon_comment}</td>
                <td>{setsumonTypeLabel}</td>
                <td>{survey.setsumon_sort}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
    if (surveyMediumQuestionList.length) {
      mediumQuestionData = (surveyMediumQuestionList.map((survey) => {
        return (
          <tr key={survey.id} onClick={(e) => this.mediumselected(survey, e)}>
            <td>{survey.setsumon_text}</td>
            <td>{survey.setsumon_comment}</td>
          </tr>
        );
      }));
    } else {
      mediumQuestionData = (
        <tr>
          <td style={{ textAlign: 'center' }} colSpan="2">データがありません</td>
        </tr>
      );
    }
    return {bigQuestionData, mediumQuestionData};
  }
  renderSurveyQustionSmallListBox(state) {
    let surveyBigQuestion = state.surveyQuestionSettingList.bigQuestions;
    let surveyMediumQuestion = state.surveyQuestionSettingList.mediumQuestions;
    let surveySmallQuestionList = state.surveyQuestionSettingList.smallQuestions;

    // id の昇順でソート
    if (Array.isArray(surveySmallQuestionList) && surveySmallQuestionList.length > 0) {
      surveySmallQuestionList = surveySmallQuestionList.sort((a, b) => a.id - b.id);
    }
    const bigSetsumonTypeOptions = [
      { value: 1, label: '回答会社連絡先等' },
      { value: 2, label: '質問事項' },
    ]
    const setsumonTypeOptions = [
      { value: '', label: '選択してください' },
      { value: 0, label: 'テキスト' },
      { value: 1, label: 'ラジオボタン' },
      { value: 2, label: '都道府県選択' },
      { value: 3, label: '支部名選択' },
      { value: 4, label: '選択肢①～⑤' },
      { value: 5, label: '選択肢①～④' },
      { value: 6, label: '選択肢①～③' },
      { value: 7, label: '職長、技能工' },
      { value: 8, label: '工事現場数' },
      { value: 9, label: '選択肢①～⑧' },
    ];

    let bigQuestionData = {};
    let mediumQuestionData = {};
    let smallQuestionData = {};
    bigQuestionData = (
      <table className="table table-hover tablesorter">
        <thead>
          <tr>
            <th width="30%">大設問タイトル</th>
            <th>大設問コメント</th>
            <th width="15%">大設問タイプ</th>
            <th width="7%">ソート順</th>
          </tr>
        </thead>
        <tbody>
          {surveyBigQuestion.map((survey) => {
            const foundOption = bigSetsumonTypeOptions.find(option => option.value == survey.setsumon_type);
            const setsumonTypeLabel = foundOption ? foundOption.label : '';
            return (
              <tr key={survey.id}>
                <td>{survey.setsumon_title}</td>
                <td>{survey.setsumon_comment}</td>
                <td>{setsumonTypeLabel}</td>
                <td>{survey.setsumon_sort}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
    mediumQuestionData = (
      <table className="table table-hover tablesorter">
        <thead>
          <tr>
            <th width="30%">中設問タイトル</th>
            <th>中設問コメント</th>
          </tr>
        </thead>
        <tbody>
          {surveyMediumQuestion.map((survey) => (
            <tr key={survey.id}>
              <td>{survey.setsumon_text}</td>
              <td>{survey.setsumon_comment}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
    if (surveySmallQuestionList.length) {
      smallQuestionData = (surveySmallQuestionList.map((survey) => {
        const foundOption = setsumonTypeOptions.find(option => option.value === survey.setsumon_type);
        const setsumonTypeLabel = foundOption ? foundOption.label : '';
        return (
          <tr key={survey.id} onClick={(e) => this.smallselected(survey, e)}>
            <td>{survey.setsumon_text}</td>
            <td>{survey.setsumon_text2}</td>
            <td>{setsumonTypeLabel}</td>
          </tr>
        );
      }));
    } else {
      smallQuestionData = (
        <tr>
          <td style={{ textAlign: 'center' }} colSpan="4">データがありません</td>
        </tr>
      );
    }
    return {bigQuestionData, mediumQuestionData, smallQuestionData};
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  zeroPack (text) {
    return ('0' + text).slice(-2)
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const pageNavi = this.renderPageNavi()
    let surveyQuestionSettingList = {}
    if(this.serveyCategory === "big") {
      surveyQuestionSettingList = this.renderSurveyQustionBigListBox(this.state)
      return (
        <div>
          {pageNavi}
          <section className='page container'>
            <div className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>アンケート設問情報</h5>
              </div>
              <div className='box-content box-table'>
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th width="30%">大設問タイトル</th>
                      <th>大設問コメント</th>
                      <th width="15%">大設問タイプ</th>
                      <th width="7%">ソート順</th>
                    </tr>
                  </thead>
                  <tbody>
                    {surveyQuestionSettingList}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      )
    } else if(this.serveyCategory === "medium") {
      const { bigQuestionData, mediumQuestionData } = this.renderSurveyQustionMediumListBox(this.state)
      return (
        <div>
          {pageNavi}
          <section className='page container'>
            <div className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>アンケート設問情報</h5>
              </div>
              <div className='box-content box-table'>
                {bigQuestionData}
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th width="30%">中設問タイトル</th>
                      <th>中設問コメント</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mediumQuestionData}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      )
    } else if(this.serveyCategory === "small") {
      const { bigQuestionData, mediumQuestionData, smallQuestionData } = this.renderSurveyQustionSmallListBox(this.state)
      return (
        <div>
          {pageNavi}
          <section className='page container'>
            <div className='box'>
              <div className='box-header'>
                <i className='icon-info-sign icon-large' />
                <h5>アンケート設問情報</h5>
              </div>
              <div className='box-content box-table'>
                {bigQuestionData}
                {mediumQuestionData}
                <table className='table table-hover tablesorter'>
                  <thead>
                    <tr>
                      <th width="30%">小設問タイトル</th>
                      <th>小設問コメント</th>
                      <th>小設問タイプ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {smallQuestionData}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      )
    }
  }
}

export default SurveyQuestionList



// WEBPACK FOOTER //
// ./src/common/pages/secure/SurveyQuestionList.js